import { UserGeneralProfile } from "@jugl-web/rest-api";
import { useCallback, useRef } from "react";
import { UserId } from "./types";

type EntityId = string;
type CacheKey = `${EntityId}-${UserId}`;

export const useUserProfileCache = () => {
  const cacheRef = useRef(new Map<CacheKey, UserGeneralProfile>());

  const getKey = useCallback(
    (entityId: string, userId: string): CacheKey => `${entityId}-${userId}`,
    []
  );

  const getCachedUserProfile = useCallback(
    (entityId: string, userId: string): UserGeneralProfile | null =>
      cacheRef.current.get(getKey(entityId, userId)) ?? null,
    [getKey]
  );

  const setCachedUserProfile = useCallback(
    (entityId: string, userId: string, profile: UserGeneralProfile) => {
      cacheRef.current.set(getKey(entityId, userId), profile);
    },
    [getKey]
  );

  return {
    getCachedUserProfile,
    setCachedUserProfile,
  };
};
